import {Injectable} from '@angular/core';
import {
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpInterceptor
} from '@angular/common/http';
import {Observable} from 'rxjs';

export const PORTAL_CODE = 'PurchasePortal';

@Injectable()
export class PortalCodeInterceptor implements HttpInterceptor {
  public intercept(request: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    request = request.clone({
      setHeaders: {
        'X-Portal-Code': PORTAL_CODE
      }
    });
    return next.handle(request);
  }
}
